import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable"
import useFullPageLoader from "../../../hooks/useFullPageLoader"
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";

function ListadoDevoluciones() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_TIPOS_TELAS = process.env.REACT_APP_URL_TIPOS_TELAS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_DEVOLUCIONES = process.env.REACT_APP_URL_DEVOLUCIONES;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_DEVOLUCIONES = process.env.REACT_APP_URL_ARTICULOS_DEVOLUCIONES;

  const [surtidos, setSurtidos] = useState([]);
  const [devoluciones, setDevoluciones] = useState([]);
  const [articulosOC, setArticulosOC] = useState([]);
  const [ordenesSurtido, setOrdenesSurtido] = useState([]);
  const [selectedOrden, setSelectedOrden] = useState("");
  const [articulos, setArticulos] = useState([]);
  const [tipos_telas, setTiposTelas] = useState([]);
  const [selectedTiposTelasFiltro, setSelectedTiposTelasFiltro] = useState("");
  const [colores, setColores] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  
  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState("");

  const [fecha, setFecha] = useState("");
  const [pedimento, setPedimento] = useState("");
  const [factura_cliente, setFacturaCliente] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [partida, setPartida] = useState("");
  const [aduana, setAduana] = useState("");
  const [fecha_aduana, setFechaAduana] = useState("");
  const [pais_origen, setPaisOrigen] = useState("");
  const [numero_surtido, setNumeroSurtido] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [selectedClienteEdit, setSelectedClienteEdit] = useState("");

  const [articulosSurtido, setArticulosSurtido] = useState([]);
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  const [total_kilos_edit, setTotalKilosEdit] = useState(0);
  const [total_metros_edit, setTotalMetrosEdit] = useState(0);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulosOC:"",
      articulos: "",
      unidad: "",
      colores: "",
      cantidad: 0,
      clave:"",
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [activo, setActivo] = useState('');

    //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50

  useEffect(() => {
    axios
      .get(URL_DEVOLUCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDevoluciones = response.data;
    // Array para pagination
    let arrayTabla = allDevoluciones
    .sort((a, b) => (a.idDevolucion > b.idDevolucion ? 1 : -1))
    .map((a) => {
      return {
        _id:a._id,
        fecha: a.fecha,
        user: a.user[0].nombre + " " + a.user[0].apellido,
        idUser: a.user[0]._id,
        surtidos: a.surtidos[0].idSurtido,
        idSurtido: a.surtidos[0]._id,
        pedidos: a.surtidos[0].pedidos[0].idPedido,
        idPedido: a.surtidos[0].pedidos[0]._id,
        clientes: a.surtidos[0].pedidos[0].clientes[0].nombre_comercial,
        idClientes: a.surtidos[0].pedidos[0].clientes[0]._id,
        observaciones: a.observaciones,
        numero: a.idDevolucion,
        total_general: a.total_general,
        is_active: a.is_active,
        aplicada: a.aplicada,
      };
    }).filter(function (el) {
      return el != null;
    });

    let dataFinal = Object.values(arrayTabla);
    setDevoluciones(allDevoluciones);
    setComments(dataFinal)
    //

      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

  }, []);

  const ListaDevoluciones = comments.sort((a, b) =>
    a.idDevolucion > b.idDevolucion ? 1 : -1
  );


  function PDFTabla() {
    const data = ListaDevoluciones.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
            (selectedCliente == 0 ||
              selectedCliente == a.idClientes)
      ) {
        return [
          a.fecha,
          a.clientes,
          a.surtidos,
          a.user
         ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
        if(user.empresa =="Shaltex"){
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    }else{  
    img2.src = process.env.PUBLIC_URL + "logoInstitucionMezclilla.png";
    }
    doc.addImage(img2, "png", 140, 20, 60, 25);
    doc.text(`Listado de Devoluciones`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Fecha", "Cliente", "Surtido", "Recibio"]],
      body: dataPDFLimpia,
      startY: 50,
    });
    doc.save(`Devoluciones.pdf`);
  }

  function excel() {
    const dataExcel = ListaDevoluciones.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
            (selectedCliente == 0 ||
              selectedCliente == a.idClientes)
      ) {
        return {
          Fecha: a.fecha,
          Cliente: a.clientes,
          Surtido: a.surtidos,
          Recibio: a.user
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoDevoluciones";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoDevoluciones",
        sheetFilter: ["Fecha", "Cliente", "Surtido", "Recibio"],
        sheetHeader: ["Fecha", "Cliente", "Surtido", "Recibio"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = ListaDevoluciones.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
            (selectedCliente == 0 ||
              selectedCliente == a.idClientes)
      ) {
        return [
          a.fecha,
          a.clientes,
          a.surtidos,
          a.user
         ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
        if(user.empresa =="Shaltex"){
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    }else{  
    img2.src = process.env.PUBLIC_URL + "logoInstitucionMezclilla.png";
    }
    doc.addImage(img2, "png", 140, 20, 60, 25);
    doc.text(`Listado de Devoluciones`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Fecha", "Cliente", "Surtido", "Recibio"]],
      body: dataPDFLimpia,
      startY: 50,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Devoluciones",
          email: mailTo,
          fileName: "ListadoDevoluciones.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Devoluciones.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Enviado con Exito!",
          showConfirmButton: false,
          timer: 2000,
        });
        setMailTo("")
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

 async function PDFOC(   
  fecha,
  idClientes,
  clientes,
  observaciones,
  numero,
  idPDFOC,
  surtidos ) {
     
     await axios
      .get(`${URL_ARTICULOS_DEVOLUCIONES}/devolucion/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosSurtido = response.data
        let arrayTabla = allArticulosSurtido
        .map((a) => {
          return {
            id:a.inventarios[0]._id,
            articulos: a.inventarios[0].articulos[0].codigo + " " + a.inventarios[0].articulos[0].nombre,
            idColor: a.inventarios[0].colores[0]._id,
            colores: a.inventarios[0].colores[0].name,
            unidad: a.inventarios[0].articulos[0].unidad,
            cantidad: a.inventarios[0].cantidad,
            cantidadString: a.inventarios[0].cantidad.toString(),
            clave: a.inventarios[0].clave,
          };
        }).filter(function (el) {
          return el != null;
        });
    
        let dataFinal = Object.values(arrayTabla);  
        let cantidadRollos = dataFinal.length
        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"] + item["idColor"] + item["clave"]
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            idColores: item.idColores,
            cantidad: 0,
            rollos: 0,
            cantidadString: "",
          };
          groups[val].cantidad += item.cantidad;
          groups[val].cantidadString += item.cantidadString + " / ";
          groups[val].articulos = item.articulos;
          groups[val].colores = item.colores;
          groups[val].idColor = item.idColor;
          groups[val].unidad = item.unidad;
          groups[val].precio = item.precio;
          groups[val].descuento = item.descuento;
          groups[val].clave = item.clave;
          groups[val].rollos += 1;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);
    
        let mts = agrupadoValues.filter(e=>e.unidad == "Metros")
        let totalMts = mts.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);
        setTotalMetrosEdit(TM);
        let KG = agrupadoValues.filter(e=>e.unidad == "Kilos")
        let totalKG = KG.map((c) => parseFloat(c.cantidad));
        let TK = totalKG.reduce((t, total, index) => t + total, 0);
        setTotalKilosEdit(TK);

        let total_importe = 0
        const data = agrupadoValues.map((a) => {
             total_importe = total_importe + (a.precio * a.cantidad)
            return [
              a.articulos,
              a.colores,
              a.clave,
              a.rollos,
              new Intl.NumberFormat("en-US").format(a.cantidad),
              a.cantidadString
             ]
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF("landscape");
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 230, 30, 45, 15);
        var img2 = new Image();
            if(user.empresa =="Shaltex"){
              img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
              }else{  
              img2.src = process.env.PUBLIC_URL + "logoInstitucionMezclilla.png";
              }
        doc.addImage(img2, "png", 120, 15, 60, 25);
        doc.text(`Devolución # ${numero}`, 20, 20);
        doc.setFontSize(12)
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Cliente ${clientes}`, 20, 30);
        doc.text(`Surtido # ${surtidos}`, 20, 35);
        doc.text(`Metros ${new Intl.NumberFormat("en-US").format(TM)} / Kilos ${new Intl.NumberFormat("en-US").format(TK)} / Rollos ${new Intl.NumberFormat("en-US").format(cantidadRollos)}`, 20, 40)
        doc.autoTable({
          head: [["Articulo","Color", "Clave", "Rollos", "Cantidad","Desgloce Rollos"]],
          body: dataPDFLimpia,
          startY: 45,
          foot: [
            [
              "",
              "",
              "",
              "",
            ],
          ],
          showFoot: "lastPage",
        });
        doc.save(`Devolucion-${numero}.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // async function ExcelOC(   
  //   fecha,
  //   idClientes,
  //   clientes,
  //   observaciones,
  //   numero,
  //   idPDFOC,
  //   surtidos ) {
       
  //      await axios
  //       .get(`${URL_ARTICULOS_DEVOLUCIONES}/devolucion/${idPDFOC}`, {
  //         headers: {
  //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //         },
  //       })
  //       .then((response) => {
  //         let allArticulosSurtido = response.data
  //         let arrayTabla = allArticulosSurtido
  //         .map((a) => {
  //           return {
  //             id:a.inventarios[0]._id,
  //             articulos: a.inventarios[0].articulos[0].codigo + " " + a.inventarios[0].articulos[0].nombre,
  //             idColor: a.inventarios[0].colores[0]._id,
  //             colores: a.inventarios[0].colores[0].name,
  //             unidad: a.inventarios[0].articulos[0].unidad,
  //             cantidad: a.inventarios[0].cantidad,
  //             cantidadString: a.inventarios[0].cantidad.toString(),
  //             clave: a.inventarios[0].clave,
  //           };
  //         }).filter(function (el) {
  //           return el != null;
  //         });
      
  //         const dataExportExcel = Object.values(arrayTabla);
  //         const dataExcelLimpia = dataExportExcel.filter(function (el) {
  //           return el != null;
  //         });

  //         var option = {};

  //         option.fileName = `Surtido-${numero}`;

  //         option.datas = [
  //           {
  //             sheetData: dataExcelLimpia,
  //             sheetName: "Devolucion",
  //             sheetFilter: [
  //               "id",
  //               "articulos",
  //               "unidad",
  //               "colores",
  //               "clave",
  //               "cantidad",
  //             ],
  //             sheetHeader: [
  //               "id",
  //               "articulos",
  //               "unidad",
  //               "colores",
  //               "clave",
  //               "cantidad",
  //             ],
  //           },
  //         ];

  //         var toExcel = new ExportJsonExcel(option);
  //         toExcel.saveExcel();
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }

  function cancelarDevolucion(idDev, numero) {
    Swal.fire({
      title: "¿Cancelar la devolución " + numero + "?",
      text: "Sólo procede si NO está aplicada. Se restauran los rollos a 'vendidos' en la nota original, se reactivan los renglones del surtido y se eliminan los acumulados/registros de rollos devueltos.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${URL_DEVOLUCIONES}Cancel/${idDev}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((resp) => {
            const d = resp.data || {};
            const conflictos =
              d.conflictos && d.conflictos.length
                ? "\n\nConflictos:\n" +
                  d.conflictos
                    .map((c) => `• ${c.clave || ""}: ${c.motivo}`)
                    .join("\n")
                : "";
            axios.post(
              URL_LOGS,
              {
                tipo: "Cancelar Devolucion",
                detalle: `Devolucion: ${numero} / Reparados: ${d.reparados || 0}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire(
              "Listo",
              `Candidatos: ${d.candidatos || 0}\nReparados: ${d.reparados || 0}${conflictos}`,
              "success"
            );
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          })
          .catch((error) => {
            const data = error?.response?.data || {};
            Swal.fire({
              icon: "error",
              title: "No se pudo cancelar",
              text: data.error || "Error al cancelar la devolución",
            });
            console.log(error);
          });
      }
    });
  }

  function QRGen(id) {
    axios
      .get(`${URL_ARTICULOS_DEVOLUCIONES}/devolucion/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allRollos = response.data;

        const doc = new jsPDF("p", "mm", [102,80])
        let alturaLogo = 30;
        let alturaImagen = 60;
        let alturaTexto1 = 43;
        let alturaTexto2 = 48;
        let alturaTexto3 = 53;
        let alturaTexto4 = 58;
        let alturaTexto5 = 68;
        let alturaLogo2 = 35;

        allRollos
        .sort((a, b) => (a.captura > b.captura ? 1 : -1))
        .map((a) => {
          let codigo = a.inventarios[0]._id;
          var base64 = qrcode.toDataURL(codigo);
          var img = new Image();
          img.src = process.env.PUBLIC_URL + "Logo-Lynqro-Negro.png";
          doc.addImage(img, "png", 70, alturaLogo, 35, 10,null,null,90);

          var img3 = new Image();
          img3.src = base64;
          doc.addImage(img3, "png", 0, alturaImagen, 40, 40);

          doc.setFontSize(14);
          doc.text(`Cod ${a.articulos[0].codigo}`, alturaTexto1,90,null,90);
          doc.text(`Mod ${a.articulos[0].nombre}`, alturaTexto2,90,null,90);
          doc.text(`Color ${a.colores[0].name} / clave ${a.clave}`, alturaTexto3,90,null,90);
          doc.text(`ID ${a.inventarios[0]._id}`, alturaTexto4,90,null,90);
          doc.setFontSize(35);
          doc.text(`${a.inventarios[0].cantidad}`, 20, 55, null, 90);
          doc.text(`${a.articulos[0].unidad}`, 35, 60, null, 90);
          doc.addPage();
        });
        doc.save(`QR.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Surtido", field: "surtidos", sortable: true },
    { name: "Recibio", field: "user", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
];

  const commentsData = useMemo(() => {
    let computedComments = comments

    if (search) {
        computedComments = computedComments.filter(
            comment =>
                comment.user.toLowerCase().includes(search.toLowerCase()) ||
                comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
                comment.surtidos.toString().includes(search)||
                comment.numero.toString().includes(search)
        );
    }
    if(selectedCliente){
      computedComments = computedComments.filter((e)=>
      e.idClientes.includes(selectedCliente)
      ) 
    } 
    if(selectedUser){
      computedComments = computedComments.filter((e)=>
      e.idUser.includes(selectedUser)
      ) 
    } 

    if(selectedFechaInicio){
      computedComments = computedComments.filter((e)=>
      e.fecha >= selectedFechaInicio
      ) 
    }
  
    if(selectedFechaFin){
      computedComments = computedComments.filter((e)=>
      e.fecha <= selectedFechaFin
      ) 
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field && sorting.field != "surtidos" && sorting.field != "numero") {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (sorting.field && sorting.order === "asc" && (sorting.field == "surtidos" || sorting.field == "numero")) {
      computedComments = computedComments.sort(
        (a, b) => parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (sorting.field && sorting.order === "desc" && (sorting.field == "surtidos" || sorting.field == "numero")) {
      computedComments = computedComments.sort(
        (a, b) => parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
}, [comments, currentPage, search, sorting, selectedCliente, selectedUser, selectedFechaInicio, selectedFechaFin]);



  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_pedidos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.pedidos_create ? (
                <>
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/DevolucionesCreate"
                >
                  Nueva Devolucion
                </Button>
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/DevolucionesSinCreate"
                >
                  Devolucion Sin Etiqueta
                </Button>
                </>
              ) : (
                <>
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Devolucion
                </Button>
                {/* <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Devolucion Surtido Completo
                </Button> */}
                </>
              )}
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Devolcuiones</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Devoluciones</h3>
          <div className="row">
                        <div className="col-md-8">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
                        <div className="col-md-4 d-flex flex-row-reverse">
                            <Search
                                onSearch={value => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                }}
                            />
                        </div>
                    </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value)
                  setCurrentPage(1)
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) => (a.razon_social > b.razon_social ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.razon_social}</option>;
                  })}
              </Input>
            </Col>
          </Row>
            <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
                <TableHeader
                            headers={headers}
                            onSorting={(field, order) =>
                                setSorting({ field, order })
                            }
                        />
            <tbody>
              {commentsData.map((a) => {
                 if(a.is_active == "No" || a.total_general == 0){
                  return (
                    <tr style={{ backgroundColor: "#ed8c8c" }}>
                    <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.surtidos}</td>
                      <td>{a.user}</td>
                      <td>CANCELADA</td>
                    </tr>
                  );
                 }else{
                  return (
                    <tr>
                    <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.surtidos}</td>
                      <td>{a.user}</td>
                      <td>
                          <Button
                          size="sm"
                          className="btn"
                          color="danger"
                          onClick={(e) => PDFOC( 
                            a.fecha,
                            a.idClientes,
                            a.clientes,
                            a.observaciones,
                            a.numero,
                            a._id,
                            a.surtidos )}
                        ><i class="far fa-file-pdf"></i>
                        </Button>
                        {/* <Button
                        size="sm"
                        className="btn"
                        color="primary"
                        onClick={(e) =>
                          ExcelOC(
                            a.fecha,
                            a.idClientes,
                            a.clientes,
                            a.observaciones,
                            a.numero,
                            a._id,
                            a.pedidos
                          )
                        }
                      >
                        <i class="far fa-file-excel"></i>
                      </Button> */}
                        <Button
                        size="sm"
                        className="btn"
                        color="success"
                        onClick={(e) =>
                          QRGen(
                            a._id,
                          )
                        }
                      >
                        <i class="fas fa-qrcode"></i>
                      </Button>
                      {a.aplicada !== "Si" ? (
                        <Button
                          size="sm"
                          className="btn"
                          color="warning"
                          title="Cancelar devolución (sólo no aplicada)"
                          onClick={(e) => cancelarDevolucion(a._id, a.numero)}
                        >
                          <i className="fas fa-ban"></i>
                        </Button>
                      ) : undefined}
                      </td>
                    </tr>
                  );
                 }
  
                
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
        </div>
      ) : undefined}
      <br />


      

      {loader}
    </>
  );
}

export default ListadoDevoluciones;
